import { Col, Row, Typography } from "antd";
import dayjs from "dayjs";
import React from "react";
import { useTranslation } from "react-i18next";
import { ACCEPTED, CREATOR, DELIVERED, FAN, MESSAGE_TIME_FORMAT } from "../../helpers/constant";
import { IMessage } from "../../helpers/types";
import StatusIcon from "../../assets/icons/status-circle-black.svg";
import MessageReadStatusIndicator from "../MessageReadStatusIndicator/MessageReadStatusIndicator";
import "./index.less";

type props = {
  message: IMessage;
  userRole?: string;
};

export const HourComponent = ({ messageTime, isRead }: { messageTime: dayjs.Dayjs; isRead: boolean }) => {
  return (
    <div
      style={{
        minWidth: "45px",
        height: "20px",
        display: "flex",
        alignItems: "flex-end",
        justifyContent: "flex-end",
        gap: "2px",
        flexShrink: 0,
      }}
    >
      {messageTime && (
        <Typography.Text className={`message-time`} style={{ paddingLeft: "8px", marginBottom: "1px", whiteSpace: "nowrap" }}>
          {messageTime.format(MESSAGE_TIME_FORMAT)}
        </Typography.Text>
      )}
      <MessageReadStatusIndicator isRead={isRead || false} />
    </div>
  );
};

const MessageTextItemComponent: React.FC<props> = ({ message, userRole }) => {
  const { t } = useTranslation();
  const messageTime = dayjs(message.createdAt);

  const condition: boolean =
    (userRole === FAN && message?.status !== ACCEPTED) || ![ACCEPTED, DELIVERED].includes(message.status!) || userRole === CREATOR;

  return (
    <>
      <div
        className="messageTextItem"
        style={{
          display: "flex",
          flexDirection: condition ? "row" : "column",
          alignItems: "center",
        }}
      >
        <Row style={{ width: "100%" }}>
          <Col span={24}>
            <div
              style={{
                display: "flex",
                alignItems: "flex-end",
                width: "100%",
              }}
            >
              <Typography.Text className="send-message-text">{message.text}</Typography.Text>
            </div>
          </Col>
        </Row>

        <Row
          style={{
            width: `${[ACCEPTED, DELIVERED].includes(message.status!) && userRole !== CREATOR ? "100%" : "fit-content"}`,
            alignSelf: "flex-end",
            alignItems: "center",
          }}
        >
          <Col
            style={{
              width: "100%",
              display: "flex",
              justifyContent: [ACCEPTED, DELIVERED].includes(message.status!) && userRole !== CREATOR ? "space-between" : "flex-end",
              alignItems: "center",
            }}
          >
            {[ACCEPTED, DELIVERED].includes(message.status!) && userRole !== CREATOR && (
              <div style={{ display: "flex", alignItems: "center" }}>
                <img src={StatusIcon} alt={message.status} />
                <Typography.Text className="font-14-bold text-black-color pl-4">{t(message.status!)}</Typography.Text>
              </div>
            )}

            <HourComponent messageTime={messageTime} isRead={message.isRead || false} />
          </Col>
        </Row>
      </div>
    </>
  );
};

export default MessageTextItemComponent;
